export default __webpack_public_path__ + "static/media/jpeg.570714fc.png";